import { GROUP_ORDERS_STORE_BASE_URL } from '@/constants/Config';

export const resolveStoreCheckoutPreviewStoreId = (
  storeIdFromQuery: string | null,
  editStoreOrderId?: string | null
): string | null => {
  if (storeIdFromQuery) {
    return storeIdFromQuery;
  }

  if (editStoreOrderId && /^\d+$/.test(editStoreOrderId)) {
    return editStoreOrderId;
  }

  return null;
};

export const buildStorePreviewUrl = (
  storeId: string | number | null | undefined
): string | null => {
  if (storeId == null || storeId === '') {
    return null;
  }

  const baseUrl = GROUP_ORDERS_STORE_BASE_URL?.replace(/\/$/, '') ?? '';

  if (!baseUrl) {
    return null;
  }

  return `${baseUrl}/store?id=${storeId}`;
};

export const openStorePreview = (storeId: string | number | null | undefined): void => {
  const previewUrl = buildStorePreviewUrl(storeId);

  if (previewUrl) {
    window.open(previewUrl, '_blank', 'noopener,noreferrer');
  }
};
